export default __webpack_public_path__ + "static/media/email-icon.2ba588b9.svg";